import { ProjectType } from '../constants'
import { ApartmentRouteContext, HouseAndLandRouteContext } from './routeContext'

export enum ApartmentRoute {
  Vision = 'vision',
  InteractiveMap = 'interactive-map',
  VideoGallery = 'video-gallery',
  Gallery = 'gallery',
  Teams = 'teams',
  Brochure = 'brochure',
  Shortlist = 'shortlist',
  AreaView = 'area-view',
  LevelView = 'level-view',
  Building = 'building',
  ThreeD = '3d',
}

export enum HouseAndLandRoute {
  Vision = 'vision',
  InteractiveMap = 'interactive-map',
  VideoGallery = 'video-gallery',
  Gallery = 'gallery',
  Teams = 'teams',
  Brochure = 'brochure',
  Shortlist = 'shortlist',
  AreaView = 'area-view-house-and-land',
  Precinct = 'precinct',
  Stage = 'stages',
}

export enum DefaultRouteParamKey {
  Page = 'page',
  Project = 'project',
  ProjectType = 'project-type',
}

interface DefaultRouteParams {
  [DefaultRouteParamKey.Page]?: string
  [DefaultRouteParamKey.Project]?: string
  [DefaultRouteParamKey.ProjectType]?: string
}

export type ApartmentRouteParams = DefaultRouteParams & ApartmentRouteContext

export type HouseAndLandRouteParams = DefaultRouteParams &
  HouseAndLandRouteContext

interface BaseParsedRoute {
  fullpath: string
  pathParams: string
  isValid: true
}

export interface InvalidParsedRoute {
  fullpath?: unknown
  pathParams?: unknown
  route?: unknown
  routeParams?: unknown
  projectType?: unknown
  isValid: false
}

export interface ParsedApartmentRoute extends BaseParsedRoute {
  route: ApartmentRoute
  routeParams: ApartmentRouteParams
  projectType: ProjectType.Apartment
}

export interface ParsedHouseAndLandRoute extends BaseParsedRoute {
  route: HouseAndLandRoute
  routeParams: HouseAndLandRouteParams
  projectType: ProjectType.HouseAndLand
}
